import React from "react";
import { Box, Button, Stack, Tooltip } from "@mui/material";
import MyLabel from "../../../components/myLabel";
import { useTheme } from "@emotion/react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

const SecaoArea = ({templateFormulario, templateSecoes, templateSecao, modal, dialog}) => {

    const theme = useTheme();

    
    if (templateSecao.value?.titulo=== null && templateSecao.value?.titulo==='') {
        templateSecao.set(null)            
    }

    const handlerLine = (row)=>{
        if (templateSecao.value && templateSecao.value.id && templateSecao.value.id === row.id){
            templateSecao.set(null)    
        }
        else{
            templateSecao.set(row)
        }
    }

    const dragEnded = (param) => {
        const { source, destination } = param;
        let _arr = [...templateSecoes.value];
        //extracting the source item from the list
        const _item = _arr.splice(source.index, 1)[0];
        //inserting it at the destination index.
        _arr.splice(destination.index, 0, _item);
        let cont = 0
        _arr = _arr.map(item=>{
            cont +=1
            return {
            ...item, ordem:cont}
                
        })
        templateSecoes.set(_arr);
      };

      if (templateFormulario?.id && templateFormulario?.id > 0){

    

    return (
        <Stack spacing={1}>
            <Box sx={{display:'flex', justifyContent:'space-between'}}>
                <MyLabel sx={{ fontSize: "15pt", fontWeight: 600, color: theme.palette.primary.main}} component='h1' text={'Seção'}/>
                <Box>
                    <Tooltip title={`Adicionar Seção`} placement="left" arrow>
                        <Button onClick={()=>{
                            templateSecao.set({templateformulario:templateFormulario?.id, titulo:'', ordem:templateSecoes.value.length+1})
                            modal()
                        }}><AddCircleOutlineIcon /></Button>
                    </Tooltip>
                </Box>
            </Box>
            <Box>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="simple table">
                    <TableHead sx={{backgroundColor: theme.palette.primary.main, color:'#FFF'}}>
                        <TableRow>
                            <TableCell sx={{color:'#FFF'}} ></TableCell>
                            <TableCell sx={{color:'#FFF'}} >Titulo</TableCell>
                            <TableCell align="right" sx={{color:'#FFF'}}></TableCell>
                        </TableRow>
                    </TableHead>
                    <>
                    <DragDropContext onDragEnd={dragEnded}>
                        <Droppable droppableId="secoes">
                            {(provided, snapshot) => (
                                <TableBody ref={provided.innerRef} {...provided.droppableProps}>
                                    {templateSecoes.value.sort((a, b) => a.ordem - b.ordem).map((row, index) => {
                                        return (
                                            <Draggable
                                                draggableId={`secao-${row.id}`}
                                                index={index}
                                                key={row.id}
                                                >
                                            {(_provided, _snapshot) => (
                                                    <TableRow 
                                                        ref={_provided.innerRef} {..._provided.draggableProps} {..._provided.dragHandleProps}   
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: templateSecao.value && templateSecao.value.id && templateSecao.value.id === row.id ? theme.palette.secondary.main : 'white'}}
                                                    >
                                                        <TableCell {..._provided.dragHandleProps} component="th" scope="row"
                                                            isDragging={_snapshot.isDragging}
                                                        >
                                                            <DragIndicatorIcon />
                                                        </TableCell>
                                                        <TableCell onClick={()=>handlerLine(row)} >{row.titulo}</TableCell>
                                                        <TableCell align="right">
                                                            <Tooltip title="Apagar" placement="bottom" arrow>
                                                                <Button color='error' disabled={row.numero_perguntas > 0}
                                                                        onClick={()=>{
                                                                                templateSecao.set(row)
                                                                                dialog()
                                                                            }} sx={{width:'55px', padding: 0,minWidth:0}}> <DeleteIcon/>
                                                                </Button>
                                                            </Tooltip>
                                                            <Tooltip title="Editar" placement="bottom" arrow>
                                                        
                                                                    <Button onClick={()=>{
                                                                        templateSecao.set(row)
                                                                        modal()
                                                                    }} sx={{width:'55px', padding: 0,minWidth:0}}><EditIcon />
                                                                    </Button>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                            )}
                                            
                                            </Draggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </TableBody>
                                )}
                        </Droppable>
                    </DragDropContext>
                    </>
                </Table>
                </TableContainer>
            </Box>
        </Stack>

    )
    }

    return <></>
}

export default SecaoArea